import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_receipt_of_wage_payment_confirmed_in_writing_by_wrkrs'

export const dataPointDefinition = {
  retracedId: 'is_the_receipt_of_wage_payment_confirmed_in_writing_by_wrkrs',
  name: 'Is the receipt of wage payment confirmed in writing by workers?',
  description:
    'The intent of this question is to understand if there is some kind of written evidence that proves that workers received wage payments (i.e. worker signature).\r\r\n\r\r\nFor example, if the facility confirms receipt of payment by obtaining the worker\'s signature as the worker is provided with his/her wage payment (via check), this response selection would be selected. \r\r\n\r\r\nIf worker receives wage payment via bank transfer, the response selection should be "not applicable"',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-16--4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8730,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
